<template>
    <Link :href="'/song/' + song.id"
        class="w-full hover:bg-nomad-accent text-nomad-200 hover:text-nomad-900 bg-nomad-800 h-20 flex items-center justify-between p-3 focus:outline-none rounded-md">

        <!-- Left side: thumbnail and text -->
        <div class="flex items-center gap-3 flex-1 min-w-0">
            <!-- Thumbnail -->
            <div class="flex-shrink-0">
                <img v-if="song.meta?.image" :src="song.meta?.image" :alt="`${song.name} cover`"
                    class="h-14 w-14 object-cover rounded-md" />
            </div>
            
            <!-- Song info -->
            <div class="min-w-0">
                <h2 class="text-ellipsis overflow-hidden whitespace-nowrap">
                    {{ song.name }}
                </h2>
                <h3 class="text-md font-thin text-ellipsis overflow-hidden whitespace-nowrap" v-if="song.artist">
                    {{ song.artist.name }}
                </h3>
            </div>
        </div>

        <!-- Right side: duration -->
        <div class="flex-shrink-0">
            <span class="font-thin text-nomad-400" v-if="song.formatted_duration">{{ song.formatted_duration }}</span>
        </div>
    </Link>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { Link } from "@inertiajs/vue3";
export default {
    name: "CardSong",
    props: {
        song: Object,
    },
    components: {
        Link,
    },
    methods: {
        ...mapActions("favorites", [""]),
        ...mapActions("current", ["prepareCurrent"]),
    },
};
</script>
